var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-text-field',{attrs:{"label":_vm.$t('general.pump.parameter.key')},model:{value:(_vm.setting.key),callback:function ($$v) {_vm.$set(_vm.setting, "key", $$v)},expression:"setting.key"}}),_c('v-text-field',{attrs:{"label":_vm.$t('general.pump.parameter.label')},model:{value:(_vm.setting.label),callback:function ($$v) {_vm.$set(_vm.setting, "label", $$v)},expression:"setting.label"}}),_c('v-select',{attrs:{"items":[
      {
        value: 'bool',
        text: 'Boolean',
      },
      {
        value: 'text',
        text: 'Text',
      } ],"label":_vm.$t('general.pump.parameter.type'),"no-data-text":_vm.$t('general.forms.no_data_text')},model:{value:(_vm.setting.type),callback:function ($$v) {_vm.$set(_vm.setting, "type", $$v)},expression:"setting.type"}}),_c('v-text-field',{attrs:{"label":_vm.$t('general.pump.parameter.unit')},model:{value:(_vm.setting.unit),callback:function ($$v) {_vm.$set(_vm.setting, "unit", $$v)},expression:"setting.unit"}}),_c('v-select',{attrs:{"disabled":_vm.setting.type !== 'text',"items":[
      {
        value: '0',
        text: '0',
      },
      {
        value: '0.0',
        text: '0.0',
      },
      {
        value: '0.00',
        text: '0.00',
      },
      {
        value: '0.000',
        text: '0.000',
      },
      {
        value: 'unformatted',
        text: 'Text',
      } ],"label":_vm.$t('general.pump.parameter.formatting'),"no-data-text":_vm.$t('general.forms.no_data_text')},model:{value:(_vm.setting.formatting),callback:function ($$v) {_vm.$set(_vm.setting, "formatting", $$v)},expression:"setting.formatting"}}),_c('v-switch',{attrs:{"label":_vm.$t('general.pump.parameter.visible')},model:{value:(_vm.setting.visible),callback:function ($$v) {_vm.$set(_vm.setting, "visible", $$v)},expression:"setting.visible"}}),_c('v-switch',{attrs:{"label":_vm.$t('general.pump.parameter.editable')},model:{value:(_vm.setting.editable),callback:function ($$v) {_vm.$set(_vm.setting, "editable", $$v)},expression:"setting.editable"}}),_c('v-btn',{attrs:{"icon":""},on:{"click":function () { return _vm.onDecreaseSort(_vm.setting.id); }}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1),_c('v-btn',{attrs:{"icon":""},on:{"click":function () { return _vm.onIncreaseSort(_vm.setting.id); }}},[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1),_c('v-btn',{attrs:{"icon":""},on:{"click":function () { return _vm.onDelete(_vm.setting.id); }}},[_c('v-icon',[_vm._v("delete")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }